import xmlJsLib from 'x2js';
export default class XMLUtils {
	x2js = new xmlJsLib();
	private static instance: XMLUtils;
	static getInstance(): XMLUtils {
		if (!XMLUtils.instance) {
			XMLUtils.instance = new XMLUtils();
		}
		return XMLUtils.instance;
	}
	parseXMLToJSON(xml: string): object {
		try {
			return this.x2js.xml2js(xml);
		} catch (e) {
			throw new Error(e.message);
		}
	}

	parseJSONToXML(json: any): string {
		try {
			return this.x2js.js2xml(json);
		} catch (e) {
			throw new Error(e.message);
		}
	}
}
